export const API_BASE_URL =
  import.meta.env.VITE_SERVER_API_URL || "http://localhost:3001";
